import { Tooltip, Typography } from 'antd';
import React from 'react';

import styles from './RichEditor.module.css';

interface EditorCharCounterProps extends React.HTMLAttributes<HTMLDivElement> {
  count: number;
  limit?: number;
}

const EditorCharCounter = ({ count, limit, ...props }: EditorCharCounterProps) => {
  return (
    <div
      className={styles.editorCounter}
      style={{ color: limit && count > limit ? 'red' : '#aaa' }}
      {...props}
    >
      {count}
      {limit ? `/${limit}` : ''}{' '}
      <Tooltip title="O contador de caracteres também contabiliza tags HTML (por exemplo, <p></p>) conforme a formatação escolhida">
        <Typography.Text underline style={{ color: limit && count > limit ? 'red' : '#aaa' }}>
          caracteres
        </Typography.Text>
      </Tooltip>
    </div>
  );
};

export default EditorCharCounter;
